import { type FunctionComponent } from 'react';
import { MEDIUM_MAX_PX } from '../../../../constants/breakpoints';
import { type Variation } from '../../../../helpers/images/images.helper';
import { CloudinaryImage } from '../../../images/cloudinary-image/cloudinary-image.component';
import { ContentCardDetails } from '../content-card-details/content-card-details.component';

export type ShowroomExperienceContentCardProps = {
	title: string;
	description: string;
	imageId: string;
	imagePosition: 'LEFT' | 'RIGHT';
};

export const ShowroomExperienceContentCard: FunctionComponent<ShowroomExperienceContentCardProps> = ({
	title,
	description,
	imageId,
	imagePosition
}) => {
	const variations: Variation[] = [{ mediaCondition: { maxWidth: MEDIUM_MAX_PX }, options: { width: 420, height: 350, crop: 'fill' } }];
	return (
		<div className="flex flex-column flex-row-ns gc4 items-center">
			<CloudinaryImage
				publicID={imageId}
				options={{ crop: 'fit' }}
				description="showroom experience"
				className="db dn-ns br2 shadow-1 mb3 w-100"
			/>
			{imagePosition === 'LEFT' && (
				<CloudinaryImage
					publicID={imageId}
					options={{ width: 720, height: 350, crop: 'fill' }}
					description="showroom experience left"
					className="dn db-ns br2 shadow-1"
					variations={variations}
				/>
			)}
			<ContentCardDetails title={title} description={description} />
			{imagePosition === 'RIGHT' && (
				<CloudinaryImage
					publicID={imageId}
					options={{ width: 720, height: 350, crop: 'fill' }}
					description="showroom experience right"
					className="dn db-ns br2 shadow-1"
					variations={variations}
				/>
			)}
		</div>
	);
};
